import { fontIsDeprecated } from '../components/templates-manager/utils';

export default [
  // DEPRECATED FONTS
  {
    fontFamily: 'Academy-Engraved',
    name: 'Academy-Engraved',
  },
  {
    fontFamily: 'Anton-Regular',
    name: 'Anton-Regular',
  },
  {
    fontFamily: 'Bangers-Regular',
    name: 'Bangers-Regular',
  },
  {
    fontFamily: 'Broadway',
    name: 'Broadway',
  },
  {
    fontFamily: 'Bubblegum-Sans',
    name: 'Bubblegum-Sans',
  },
  {
    fontFamily: 'Bungee-Shade',
    name: 'Bungee-Shade',
  },
  {
    fontFamily: 'Caveat',
    name: 'Caveat',
  },
  {
    fontFamily: 'Covered-By-Your-Grace',
    name: 'Covered-By-Your-Grace',
  },
  {
    fontFamily: 'Dancing-Script',
    name: 'Dancing-Script',
  },
  {
    fontFamily: 'Dudu-Calligraphy',
    name: 'Dudu-Calligraphy',
  },
  {
    fontFamily: 'Handlee',
    name: 'Handlee',
  },
  {
    fontFamily: 'Impact',
    name: 'Impact',
  },
  {
    fontFamily: 'Indie-Flower',
    name: 'Indie-Flower',
  },
  {
    fontFamily: 'Lucida-Handwriting-Italic',
    name: 'Lucida-Handwriting-Italic',
  },
  {
    fontFamily: 'Poppins-Bold',
    name: 'Poppins-Bold',
  },
  {
    fontFamily: 'Rage-Italic',
    name: 'Rage-Italic',
  },
  {
    fontFamily: 'Silom',
    name: 'Silom',
  },
  {
    fontFamily: 'Special-Elite',
    name: 'Special-Elite',
  },
  {
    fontFamily: 'TragicMarker',
    name: 'TragicMarker',
  },
  // NEW FONTS LIST
  {
    fontFamily: 'Baskerville-Old-Face-Italic',
    name: 'Baskerville-Old-Face-Italic',
  },
  {
    fontFamily: 'Baskerville-Old-Face',
    name: 'Baskerville-Old-Face',
  },
  {
    fontFamily: 'MarkerFelt',
    name: 'MarkerFelt',
  },
  {
    fontFamily: 'Montserrat-SemiBold',
    name: 'Montserrat-SemiBold',
  },
  {
    fontFamily: 'Pixel-Operator-Mono-Bold',
    name: 'Pixel-Operator-Mono-Bold',
  },
  {
    fontFamily: 'Yellowtail-Regular',
    name: 'Yellowtail-Regular',
  },
  {
    fontFamily: 'OstrichSans-Heavy',
    name: 'OstrichSans-Heavy',
  },
  {
    fontFamily: 'Junicode-BoldCondensed',
    name: 'Junicode-BoldCondensed',
  },
  {
    fontFamily: 'YoungSerif-Regular',
    name: 'YoungSerif-Regular',
  },
  {
    fontFamily: 'Shrikhand-Regular',
    name: 'Shrikhand-Regular',
  },
  {
    fontFamily: 'BagelFatOne-Regular',
    name: 'BagelFatOne-Regular',
  },
  {
    fontFamily: 'PermanentMarker-Regular',
    name: 'PermanentMarker-Regular',
  },
  {
    fontFamily: 'BebasNeue-Regular',
    name: 'BebasNeue-Regular',
  },
  {
    fontFamily: 'DMSerifDisplay-Italic',
    name: 'DMSerifDisplay-Italic',
  },
  {
    fontFamily: 'DMSerifDisplay-Regular',
    name: 'DMSerifDisplay-Regular',
  },
  {
    fontFamily: 'PlayfairDisplay-Regular',
    name: 'PlayfairDisplay-Regular',
  },
  {
    fontFamily: 'Raleway-Italic',
    name: 'Raleway-Italic',
  },
  {
    fontFamily: 'Raleway-Regular',
    name: 'Raleway-Regular',
  },
  {
    fontFamily: 'LeagueGothic-Italic',
    name: 'LeagueGothic-Italic',
  },
  {
    fontFamily: 'Aileron-Black',
    name: 'Aileron-Black',
  },
].sort(({ name: name1 }, { name: name2 }) => {
  if (fontIsDeprecated(name1)) return 1;
  if (fontIsDeprecated(name2)) return -1;
  return name1.localeCompare(name2);
});



// WEBPACK FOOTER //
// ./src/fonts/templates-fonts.js